import { FC, useMemo } from 'react';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { UserSubscriptionTypesEnum } from '~/common/enums/user-subscription-types.enum';
import { Typography } from '~/common/components/Typograph';
import { Modal } from '~/common/components/Modal';
import { Button } from '~/common/components/Button';

import { ModalContent } from './styles';

interface IOutOfAccessModalProps {
  openFor: UserSubscriptionTypesEnum;
  close: () => void;
}
export const OutOfAccessModal: FC<IOutOfAccessModalProps> = ({
  openFor,
  close,
}) => {
  const isMobile = useMediaQuery('(max-width: 750px)');
  const theme = useTheme();

  const text = useMemo(() => {
    if (openFor === UserSubscriptionTypesEnum.PREMIUM) {
      return 'Este recurso está disponível apenas para usuários Premium. Atualize sua assinatura para acessar todos os recursos.';
    }

    return 'Este recurso está disponível apenas para usuários Premium. Atualize sua assinatura para acessar todos os recursos.';
  }, [openFor]);

  return (
    <Modal
      isOpen={!!openFor}
      onClose={close}
      id="forbidden-prompt-modal"
      height={isMobile ? '200px' : 'auto'}
      width="400px"
      title="Acesso restrito"
    >
      <ModalContent>
        <Typography.Label
          size="medium"
          color="neutral0"
          {...(isMobile && {
            style: {
              marginBottom: 'auto',
            },
          })}
        >
          {text}
        </Typography.Label>

        <Button
          text="Visualizar planos"
          width="100%"
          backgroundColor={theme.primary}
          onClick={close}
          href="/account"
        />
      </ModalContent>
    </Modal>
  );
};
